import { render, staticRenderFns } from "./specificRequirementsSelection.vue?vue&type=template&id=7328696b&scoped=true&"
import script from "./specificRequirementsSelection.vue?vue&type=script&lang=js&"
export * from "./specificRequirementsSelection.vue?vue&type=script&lang=js&"
import style0 from "./specificRequirementsSelection.vue?vue&type=style&index=0&id=7328696b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328696b",
  null
  
)

export default component.exports